module.exports = __webpack_public_path__ + "img/right_gray.5da03163.svg";